import * as React from 'react'
import SocialAccount, { SocialAccountType } from '../../../models/socialAccount'
import { Link } from '../../../components/link'
import { Icon, IconType, facebook, instagram, twitter } from '../../../components/icon'

type FieldProps = {
    icon: SocialAccount
}

type Props = FieldProps

const networks: {[key in SocialAccountType]: { url: string, icon: IconType}} = {
    FACEBOOK: { url: 'https://www.facebook.com/', icon: facebook },
    INSTAGRAM: { url: 'https://www.instagram.com/', icon: instagram },
    TWITTER: { url: 'https://twitter.com/', icon: twitter },
}

class SocialIcon extends React.Component<Props> {
    render() {
        const { icon } = this.props
        const network = networks[icon.type]

        return (
            <li className='footer__social-icon'>
                <Link className='footer__social-link' to={`${network.url}${icon.account}`} target='_blank'>
                    <Icon className='footer__social-image' icon={network.icon} />
                </Link>
            </li>
        )
    }
}

export default SocialIcon
